document.addEventListener("DOMContentLoaded", function () {
  // Get all popup buttons
  const popupButtons = document.querySelectorAll("button[data-popup-id]");
  for (const button of popupButtons) {
    const popupId = button.getAttribute("data-popup-id");
    const popupOverlay = document.getElementById(`popupOverlay${popupId}`);
    const myPopup = document.getElementById(`myPopup${popupId}`);
    const closeBtn = myPopup.querySelector(".close-btn");

    if (button && popupOverlay && myPopup && closeBtn) {
      button.addEventListener("click", () => openPopup(myPopup, popupOverlay));
      popupOverlay.addEventListener("click", () =>
        closePopup(myPopup, popupOverlay)
      );
      closeBtn.addEventListener("click", () =>
        closePopup(myPopup, popupOverlay)
      );
    }
  }

  function openPopup(myPopup, popupOverlay) {
    myPopup.classList.add("active");
    popupOverlay.classList.add("active");
    document.body.classList.add("no-scroll");
    if (document.querySelector(".section-header")) {
      document.querySelector(".section-header").style.zIndex = "0";
    }
    if (document.querySelector(".announcement-bar")) {
      document.querySelector(".announcement-bar").style.zIndex = "0";
    }
  }

  function closePopup(myPopup, popupOverlay) {
    myPopup.classList.remove("active");
    popupOverlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
    if (document.querySelector(".section-header")) {
      document.querySelector(".section-header").style.zIndex = "400";
    }
    if (document.querySelector(".announcement-bar")) {
      document.querySelector(".announcement-bar").style.zIndex = "401";
    }
  }
});
